import type { AnchorHTMLAttributes, MouseEvent } from "react";
import { navigate } from "./navigation.js";

/** Un lien de l'app : change d'écran sans recharger la page (clic du milieu, ⌘ ou ⇧ : comportement du navigateur). */
export function Link({ to, onClick, ...rest }: AnchorHTMLAttributes<HTMLAnchorElement> & { to: string }) {
  return (
    <a
      {...rest}
      href={to}
      onClick={(e: MouseEvent<HTMLAnchorElement>) => {
        onClick?.(e);
        if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        navigate(to);
      }}
    />
  );
}
